module.exports = __webpack_public_path__ + "img/peso.737c2570.png";